require('@expo/metro-runtime');
const { Platform } = require('react-native');
// expo-dev-client is only used for native (dev builds); web uses Metro + React Native Web and does not load this module.
if (Platform.OS !== 'web') {
  require('expo-dev-client');
}
const { registerRootComponent } = require('expo');
const App = require('./App').default;

if (!__DEV__) {
  // eslint-disable-next-line no-console
  console.log = () => {};
  console.error = () => {};
  console.warn = () => {};
}

registerRootComponent(App);
